import type { Model, Question } from "survey-core";

const QUIZ_SKIP_ITEM_ID = "sv-nav-skip";

const SKIP_ITEM_CSS = "sv-action-skip";
const SKIP_ITEM_INNER_CSS = "sd-btn sd-btn-skip";

type SkipNavigationItem = {
    title: string;
    action: () => void;
    // The class `QuizRedesign` styles its Skip with; a survey that styles it otherwise leaves it out.
    isStyledAsAction?: boolean;
};

export const removeSkipNavigationItem = (survey: Model) => {
    survey["removeNavigationItem"](QUIZ_SKIP_ITEM_ID);
};

// Replaces the Skip item of the page, so a page never has two.
export const setSkipNavigationItem = (survey: Model, { title, action, isStyledAsAction = false }: SkipNavigationItem) => {
    removeSkipNavigationItem(survey);
    survey.addNavigationItem({
        id: QUIZ_SKIP_ITEM_ID,
        title,
        action,
        ...(isStyledAsAction && { css: SKIP_ITEM_CSS }),
        innerCss: SKIP_ITEM_INNER_CSS,
    });
};

// What Skip does on a page of questions: forgets the answers and moves on.
export const skipQuestions = (survey: Model, questions: Question[]) => {
    questions.forEach((question) => question.clearValue());
    survey.nextPage();
};
